import React from "react";
import {
    Drawer,
    Space,
    Button,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";

//compoenntes
import { IconSAT } from "../../Widgets/Iconos";
import FacturaTimbradoForm from "./FacturaTimbradoForm";
import "../../../Styles/Modules/Finanzas/DrawerTimbrado.scss";

/**
 * @Este drawer sirve como como contenedor principal para el formulario de timbrado de facturas
 * @param {*} props 
 * @returns 
 */
export default function DrawerFactura(props) {

    let { onClose, visible, tipo = "NC", clienteId } = props
    let [ loading, setLoading ] = React.useState(false)
    let [ disabled, setDisabled ] = React.useState(false)

    const timbradoOrden = React.createRef()

    /**
     * @description Cerramos y limpiamos el DRAWER de facturación.
     */
    let onCloseEvent = () => {
        onClose();
        setLoading(false)
        setDisabled(false)
    }

    return <Drawer
        title={<span className="title">Generación del Comprobante Fiscal Digital</span>}
        placement="right"
        onClose={onCloseEvent}
        open={visible}
        width={1300}
        style={{ maxWidth: "100%" }}
        destroyOnClose
        extra={
            <Space>
                <Button 
                    loading={loading} 
                    disabled={disabled} 
                    icon={<IconSAT 
                    size={14} 
                    color="currentColor" 
                    style={{ position: "relative", top: 2, right: 3 }} />} 
                    type="primary" 
                    onClick={() => timbradoOrden.current?.submit()}
                >
                    Timbrar
                </Button>
                <Button loading={loading} danger icon={<CloseOutlined />} onClick={onClose}>Cancelar</Button>
            </Space>
        }
    >  
        <FacturaTimbradoForm ref={timbradoOrden} tipo={tipo} cliente={props.cliente} clienteId={props.cliente?._id} onCloseEvent={onCloseEvent}/>
    </Drawer>
}